import React, { useEffect, useState } from "react";
import useQueryParams from "./useQueryParams";
import { useAppContext } from "./useAppContext";
import { createOrderItems } from "../services/cart.service";
import { useStateMachine } from "little-state-machine";
import updateAction from "../updateAction";
import useToast from "./useToast";
import {setWithExpiry} from "../helpers/localStorageExpiry";
import {COMMERCE_WEBFORM_TOKEN} from "../storage/constants";

const filterParams = ({ aid, dids, amt, freq, cc, pid, to }) => ({
  aid,
  dids,
  amt,
  freq,
  cc,
  pid,
  to,
});
const getConfigOrderParams = (queryParams) => filterParams(queryParams);

export default function useOrderConfigParams(allowConfigOrderParams) {
  const [orderConfigParams, setOrderConfigParams] = useState({});
  const queryParams = useQueryParams();
  const ctx = useAppContext();
  const { actions } = useStateMachine({ updateAction });

  const notifyCreateOrderItemError = useToast({
    type: "error",
    id: "createOrderItem",
    actionText: "RETRY?",
    action: async () => await onLoad(),
    dismissable: true,
    message: "There was a problem adding the fund to your cart.",
  });

  function onLoad() {
    const configOrderParams = getConfigOrderParams(queryParams);
    if (configOrderParams["to"]) {
      configOrderParams["to"] = configOrderParams["to"].substring(0, 400);
    }
    if (
      configOrderParams["aid"] ||
      configOrderParams["dids"] ||
      configOrderParams["to"]
    ) {
      configOrderParams["pid"]
        ? actions.updateAction({ isPledgePayment: true })
        : actions.updateAction({ isPledgePayment: false });

      // Expire webform token to generate a new cart.
      if (configOrderParams["cc"]) {
        setWithExpiry(COMMERCE_WEBFORM_TOKEN,  null, 0);
      }

      createOrderItems(configOrderParams)
        .then((r) => {
          if (r.length !== 0) {
            ctx.setLoadOrderItemList(true);
            ctx.openMenu();
          } else {
            // Show message if the fund does not exist.
            let element = document.getElementById("giving-app");
            let message = document.createElement("div");
            message.innerHTML =
              "The requested funds are not currently able to accept donations online. Please select another area of need to support, or contact us for further assistance.";
            message.classList.add("messages");
            message.classList.add("messages--error");
            element.prepend(message);
          }
        })
        .catch(() => {
          notifyCreateOrderItemError();
        });

      // Clean query params.
      delete queryParams.aid;
      delete queryParams.dids;
      delete queryParams.to;
      delete queryParams.cc;
      delete queryParams.amt;
      delete queryParams.freq;
      delete queryParams.pid;
      window.history.replaceState(
        {},
        "",
        decodeURIComponent(
          Object.keys(queryParams).length !== 0
            ? `${location.pathname}?${Object.keys(queryParams)
                .map((key) => key + "=" + queryParams[key])
                .join("&")}`
            : location.pathname
        )
      );
    }
  }

  useEffect(() => {
    if (!allowConfigOrderParams) return;
    // Adding/configuring donations via parameters passed on the URL.
    onLoad();
  }, []);

  return { orderConfigParams, setOrderConfigParams };
}
